// German SEO translations. Keep public descriptions consistent with the visible pages.
export const SEO_DE = {
  "siteName": "Praxis Keilberg",
  "socialImageAlt": "Titelbild der Website von Praxis Keilberg",
  "pages": {
    "/": {
      "title": "Heilpraktiker für Psychotherapie in Kassel – Keilberg",
      "description": "Rüdiger Keilberg, Heilpraktiker für Psychotherapie in Kassel. Entdecke meine Angebote für psychotherapeutische Begleitung, Coaching und bewusste Atemarbeit."
    },
    "/shop": {
      "title": "Kurse & digitale Inhalte | Praxis Keilberg",
      "description": "Entdecken Sie die Angebote im Shop von Praxis Keilberg. Informationen zu verfügbaren Angeboten, Inhalten und Preisen finden Sie direkt im Shop."
    },
    "/kontakt": {
      "title": "Kontakt & Erstberatung in Kassel | Praxis Keilberg",
      "description": "Nehmen Sie Kontakt mit Praxis Keilberg in Kassel auf. Hier finden Sie die Kontaktmöglichkeiten der Praxis für Fragen und Anfragen."
    },
    "/aboutme": {
      "title": "Rüdiger Keilberg – Heilpraktiker für Psychotherapie in Kassel",
      "description": "Lernen Sie die Person hinter Praxis Keilberg kennen. Erfahren Sie mehr über den persönlichen Hintergrund und die Arbeit in der Praxis."
    },
    "/staunendlernen": {
      "title": "Coaching in Kassel – Staunend lernen | Keilberg",
      "description": "Coaching in Kassel für persönliche Orientierung, Entscheidungen und Veränderungen. Lerne meine Arbeitsweise kennen und vereinbare eine unverbindliche Erstberatung."
    },
    "/eigenewege": {
      "title": "Psychotherapie nach Heilpraktikergesetz in Kassel | Keilberg",
      "description": "Psychotherapeutische Begleitung nach dem Heilpraktikergesetz in Kassel. Erfahre mehr über meine Arbeitsweise, den Ablauf und die unverbindliche Erstberatung."
    },
    "/freiheitatmen": {
      "title": "PSYCHEDELIC BREATH® in Kassel | Praxis Keilberg",
      "description": "PSYCHEDELIC BREATH® in Kassel: Informationen zum Ablauf der dynamischen Atempraxis mit Musik, zu Teilnahmevoraussetzungen und Kontraindikationen."
    },
    "/breathwork": {
      "title": "Breathwork in Kassel – bewusste Atemarbeit | Keilberg",
      "description": "Entdecke Breathwork und bewusste Atemarbeit in Kassel. Informiere Dich über unterschiedliche Atemformate, persönliche Vorbereitung und Grenzen des Angebots."
    },
    "/impressum": {
      "title": "Impressum | Praxis Keilberg",
      "description": "Impressum der Website von Praxis Keilberg: Angaben zum Anbieter und die bereitgestellten Kontaktinformationen."
    },
    "/datenschutzerklaerung": {
      "title": "Datenschutzerklärung | Praxis Keilberg",
      "description": "Datenschutzerklärung von Praxis Keilberg. Informationen zur Verarbeitung personenbezogener Daten auf dieser Website."
    },
    "/agb": {
      "title": "Allgemeine Geschäftsbedingungen | Praxis Keilberg",
      "description": "Lesen Sie die Allgemeinen Geschäftsbedingungen von Praxis Keilberg und informieren Sie sich über die geltenden Bedingungen."
    }
  }
};
